export enum Section {
  municipality = 1,
  school = 2,
}
